/*
 * Copyright (c) 2020. Legalbird eine Marke der R&S Internet Jewels GmbH
 */
import React, { ChangeEvent, ReactNode } from "react";
import Grid from "@mui/material/Grid";
import { Box, Checkbox } from "@mui/material";
import checklistRowStyle from "./checklistRowStyle";

type ChecklistRowProps = {
  checked: boolean;
  isChecked?: boolean;
  onChange?: (event: ChangeEvent<HTMLInputElement>) => void;
  label: ReactNode;
  description?: ReactNode;
  name?: string;
};

const ChecklistRow = ({ checked, isChecked, onChange, label, description, name }: ChecklistRowProps) => {
  let labelClass = checklistRowStyle.checklistLabel;

  if (checked || isChecked) {
    labelClass = {
      ...labelClass,
      ...checklistRowStyle.checked,
    };
  }

  return (
    <Grid container sx={{ columnGap: "0.5rem" }}>
      <Grid size="auto">
        <Checkbox checked={checked || isChecked} disabled={checked} onChange={onChange} name={name} />
      </Grid>
      <Grid size="grow">
        <Box sx={labelClass}>{label}</Box>
        {!(checked || isChecked) && <Box sx={checklistRowStyle.checklistDescription}>{description}</Box>}
      </Grid>
    </Grid>
  );
};

export default ChecklistRow;
